<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
    
  </div>
</template>
<script>
export default {
  name: 'App',
  data () {
    return {
      activeIndex: 'index'
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/views/index/App.vue